import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { useAuditLogQuery } from './hooks/useAuditLogQuery';
import FilterBar from './components/FilterBar';
import AuditLogTable from './components/AuditLogTable';
import AuditLogDetailDrawer from './components/AuditLogDetailDrawer';
import type { AuditLogEntry, AuditLogFilter } from '../../services/auditLogApi';

const AuditLogContent: React.FC = () => {
  const { data, total, loading, filter, search, reset, changePage } = useAuditLogQuery();
  const [detail, setDetail] = useState<AuditLogEntry | null>(null);

  useEffect(() => {
    search();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (next: Partial<AuditLogFilter>) => search(next);

  return (
    <Card title="稽核記錄查詢">
      <FilterBar loading={loading} onSearch={handleSearch} onReset={reset} />
      <AuditLogTable
        data={data}
        loading={loading}
        total={total}
        page={filter.page || 1}
        pageSize={filter.pageSize || 20}
        onPageChange={changePage}
        onViewDetail={setDetail}
      />
      <AuditLogDetailDrawer entry={detail} onClose={() => setDetail(null)} />
    </Card>
  );
};

/** SYS_AuditLog 查詢頁 — 僅管理者群組可見（docs/AUDIT_LOG_DECISION_PACKAGE.md 第四節 Q4）。
 * PermissionGuard 在頁面內把關：無權限者進入路由也只會看到 403，不會看到任何資料。 */
const AuditLogPage: React.FC = () => (
  <PermissionGuard module={Modules.AUDIT_LOG} action="query">
    <AuditLogContent />
  </PermissionGuard>
);

export default AuditLogPage;
